export type RuntimeContext = "STANDALONE" | "BROWSER"

/** Detects whether the dealer app is running installed (see `usePwaInstall`) or in a regular browser tab. */
export const getRuntimeContext = (): RuntimeContext => {
	return window.matchMedia("(display-mode: standalone)").matches ? "STANDALONE" : "BROWSER"
}
